module.exports = __webpack_public_path__ + "img/73e2a13fc578f32782d2c29cf5ae515a.svg";